<template>
    <div>
        <div></div>
    </div>
</template>
<script type="text/javascript">
    import loading from '../widgets/loading/loading.vue';
    export default {
        data() {
            return {
            }
        },
        methods: {

        },
        mounted() {
            const container = $(this.$el).children('div:first');
            const params = {
                element: container
            };
            var sendMessageHtml = "Views/SendMessage.html";
            vm.sendMessage.activate(params, sendMessageHtml);
        },
        components: {
            loading
        }
    }
</script>